var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF4500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.5 11.896c-.038-.991-.901-1.765-1.932-1.731a1.906 1.906 0 0 0-1.222.498 9.308 9.308 0 0 0-4.914-1.514l.828-3.839 2.732.554c.075.676.704 1.166 1.405 1.092.701-.073 1.209-.679 1.132-1.355-.076-.676-.704-1.165-1.405-1.092-.403.04-.765.266-.964.603l-3.129-.603a.396.396 0 0 0-.472.291v.006l-.942 4.27a9.382 9.382 0 0 0-4.978 1.514 1.91 1.91 0 0 0-2.633.08 1.75 1.75 0 0 0 .082 2.538c.146.131.314.245.501.324a3.83 3.83 0 0 0 0 .542c0 2.755 3.332 4.997 7.44 4.997 4.108 0 7.44-2.239 7.44-4.997.012-.18.012-.361 0-.542a1.79 1.79 0 0 0 1.03-1.636M7.737 13.129c0-.68.574-1.233 1.278-1.233.704 0 1.279.553 1.279 1.233 0 .678-.575 1.232-1.279 1.232-.707-.006-1.279-.554-1.279-1.232m7.414 3.431v-.049a5.028 5.028 0 0 1-3.154.948 5.027 5.027 0 0 1-3.154-.948.326.326 0 0 1 .048-.468c.127-.1.308-.1.438 0a4.278 4.278 0 0 0 2.655.774 4.314 4.314 0 0 0 2.669-.75.369.369 0 0 1 .504.007.337.337 0 0 1-.006.486m-.175-2.11h-.063l.01-.046c-.705 0-1.28-.554-1.28-1.233s.575-1.233 1.28-1.233c.704 0 1.278.554 1.278 1.233.028.68-.52 1.251-1.225 1.279"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/Reddit.b72c6e1952636454d5fa4e74a2f30157.svg";
export { ForwardRef as ReactComponent };